(() => {
  const marker = 'data-leslis-guarantee-loader';
  if (document.documentElement.hasAttribute(marker)) return;
  document.documentElement.setAttribute(marker, '');
  let script;
  let pending;
  let failed = false;
  let timeout;

  const host = () => document.querySelector('leslis-guarantee-dialog');
  const surfaceIsOpen = (surface) => !surface || (surface.isConnected &&
    (surface.hasAttribute('open') || surface.classList.contains('active')));
  const fail = () => {
    if (failed) return;
    failed = true;
    clearTimeout(timeout);
    script?.remove();
    const intent = pending;
    pending = null;
    if (!intent?.opener.isConnected || !surfaceIsOpen(intent.surface)) return;
    const message = intent.opener.closest('.leslis-guarantee')?.querySelector('[data-leslis-guarantee-error]');
    if (message) message.hidden = false;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target instanceof Element ? event.target.closest('[data-leslis-guarantee-open]') : null;
    if (!opener || event.defaultPrevented || event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (failed) {
      event.stopImmediatePropagation();
      return;
    }
    const component = host();
    const dialog = component?.querySelector('dialog');
    if (!component?.isConnected || !dialog || typeof dialog.showModal !== 'function') return;
    if (customElements.get('leslis-guarantee-dialog')) return;
    const src = component.dataset.runtimeSrc;
    if (!src) return;
    event.preventDefault();
    if (script) return;
    pending = {
      opener,
      surface: opener.closest('cart-drawer.active, quick-add-modal[open], modal-dialog[open], dialog[open]'),
    };
    script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onerror = fail;
    script.onload = () => {
      if (failed) return;
      clearTimeout(timeout);
      const intent = pending;
      pending = null;
      const current = host();
      if (!customElements.get('leslis-guarantee-dialog') || !current?.isConnected ||
        typeof current.open !== 'function' || !current.dialog) {
        pending = intent;
        fail();
        return;
      }
      if (!intent?.opener.isConnected || !surfaceIsOpen(intent.surface)) return;
      current.open(intent.opener);
    };
    timeout = setTimeout(fail, 8000);
    document.head.appendChild(script);
  }, { capture: true });
})();
